// Dependency
import React from 'react';
import {Link} from "gatsby";
import UtilsService from "../../services/utils.service";

// Styles
import * as footerStyles from './../footer/footer.module.scss'

// Template
const NavigationLists = (props) => {

    const locale = UtilsService.getLocaleFromUrl();

    return (
    <React.Fragment>

          {props && props.data && props.data.map( (infoLink, index) => {
            return (
                <div  key={index}>
                    {infoLink.url.includes('https') ? <a target="_blank" rel="noreferrer" href={infoLink.url}>{infoLink.name}</a> : <Link key={index} to={`/${locale.country}${infoLink.url}/`}>{infoLink.name}</Link>}
                </div>
            )
          } )}

    </React.Fragment>
  );
};

export default NavigationLists;